const hasPasswordForm = document.querySelector('#hasPasswordForm');

if (hasPasswordForm) {
	const siteHeader = document.querySelector('.site-header');
	const siteFooter = document.querySelector('.site-footer');

	siteHeader.style.display = 'none';
	siteFooter.style.display = 'none';
}
